import React from 'react';

import { FinansieringsbevisResponse } from '../../generated-types';
import { CONTEXT_PATH } from '../../services';
import { FUNDING_CERTIFICATE_SERVICE_PATH } from '../../services/fundingCertificatesService';
import { useTranslation } from '../../translations';
import { formatTranslation } from '../../translations/useTranslation';
import { formatDate } from '../../utils/dateUtils';
import { TaskExpandCard } from '../TaskExpandCard';
import { FundingCertificatesAttachments } from './FundingCertificatesAttachments';

interface FundingCertificateProps {
    fundingCertificates: FinansieringsbevisResponse[];
}
const FundingCertificate = ({ fundingCertificates }: FundingCertificateProps) => {
    const { fundingCertificate: fundingCertificateTranslation } = useTranslation();
    const formattedExpirationDate = (expirationDate: string) => formatDate(new Date(expirationDate));

    return fundingCertificates.map((fundingCertificate) => (
        <TaskExpandCard
            key={fundingCertificate.dokumentMetaId}
            title={fundingCertificateTranslation.title}
            description={formatTranslation(
                fundingCertificateTranslation.description,
                formattedExpirationDate(fundingCertificate.utloepsdato),
            )}
            attachments={
                <FundingCertificatesAttachments
                    fundingCertificateText={fundingCertificateTranslation.title}
                    downloadFundingCertificateUrl={`${CONTEXT_PATH}/${FUNDING_CERTIFICATE_SERVICE_PATH}/${fundingCertificate.dokumentMetaId}/dokument`}
                />
            }
        />
    ));
};

export default FundingCertificate;
